import { useLocales } from '@shared/locales'
import { Flex, Modal, Table, TableColumnsType } from 'antd'

import { ActionsType } from './types'
import { mockProducts } from '../ProductsColTrendsetter/mockData'
import { Product } from '../ProductsColTrendsetter/types'

const formatPrice = (price: number, currency = 'MDL') => {
  return `${price.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${currency}`
}

export const AddEditOffer = ({ offer, onSuccess, ...props }: ActionsType) => {
  const { t } = useLocales()

  const handleOk = () => {
    // Demo: Just close modal, in real implementation would save via API
    onSuccess?.()
    props.onCancel?.()
  }

  const productColumns: TableColumnsType<Product> = [
    {
      title: t('products_trendsetter.format_label'),
      dataIndex: 'format',
      key: 'format',
      render: (format: Product['format']) =>
        t(`products_trendsetter.format.${format}`)
    },
    {
      title: t('products_trendsetter.location_name'),
      dataIndex: 'location_name',
      key: 'location_name'
    },
    {
      title: t('products_trendsetter.address'),
      dataIndex: 'address',
      key: 'address'
    },
    {
      title: t('products_trendsetter.gross_cost'),
      dataIndex: 'gross_cost',
      key: 'gross_cost',
      render: (cost) => formatPrice(cost)
    }
  ]

  return (
    <Modal
      width={800}
      maskClosable={false}
      title={offer ? t('offers.edit_offer') : t('offers.generate_offer')}
      cancelText={t('buttons.cancel')}
      okText={offer ? t('buttons.save') : t('buttons.generate') || 'Generate'}
      onOk={handleOk}
      {...props}
    >
      {offer ? (
        <div style={{ padding: '20px 0', textAlign: 'center' }}>
          <p>{t('offers.form_placeholder')}</p>
          <p>
            {t('offers.editing')}: {offer.offer_number}
          </p>
        </div>
      ) : (
        <Flex vertical gap={16}>
          <div>
            <p style={{ marginBottom: 16 }}>
              {t('offers.select_products_to_generate') ||
                'Select products to generate offer:'}
            </p>
            <Table
              columns={productColumns}
              dataSource={mockProducts}
              rowKey="id"
              pagination={false}
              size="small"
              scroll={{ y: 400 }}
            />
          </div>
        </Flex>
      )}
    </Modal>
  )
}
